import React from "react";
import ChangePageTitle from "../components/change-title-page";
import Faq_content from "../components/component-faq";

function Faq(){

    return(
        <>
            <ChangePageTitle pageTitle="سوالات متداول | رستوران باغبان" />
            <Faq_content />
        </>
    );

}

export default Faq;